'use client';
import { DeleteAccountSettings } from '@/components/delete-account-settings';
import { PasswordAccountSettings } from '@/components/password-account-settings';
import { ProfileAccountSettingsForm } from '@/components/profile-account-settings-form';
import { Card, CardContent } from '@/components/ui/card';
import { useAccountSettings } from '@/hooks/useAccountSettings';
import { useMemo } from 'react';

export default function AccountSettings() {
  const { getAccountSettingsApi } = useAccountSettings({
    loadGetAccountSettings: true,
  });

  const { data: accountSettings } = getAccountSettingsApi;

  const shouldHidePasswordChange = useMemo(() => {
    return !accountSettings?.data.hasPassword;
  }, [accountSettings]);

  return (
    <section className="flex flex-col gap-4 p-8 max-w-5xl w-full mx-auto">
      <div className="flex items-center justify-center">
        <h1 className="font-bold text-2xl">Account Settings</h1>
      </div>
      <Card className="border-none shadow-sm">
        <CardContent className="py-2">
          <ProfileAccountSettingsForm />
        </CardContent>
      </Card>

      {!shouldHidePasswordChange && (
        <Card className="border-none shadow-sm">
          <CardContent className="py-2">
            <PasswordAccountSettings />
          </CardContent>
        </Card>
      )}

      <Card className="border-none shadow-sm">
        <CardContent className="py-2">
          <DeleteAccountSettings />
        </CardContent>
      </Card>
    </section>
  );
}
